export default __webpack_public_path__ + "static/media/heart-orange.9bed9d74.svg";